import imgOnboarding01 from '@/assets/achievements/Img-onboarding-tokens-01.png';
import imgOnboarding02 from '@/assets/achievements/Img-onboarding-tokens-02.png';
import imgOnboarding03 from '@/assets/achievements/Img-onboarding-tokens-03.png';
import imgOnboarding04 from '@/assets/achievements/Img-onboarding-tokens-04.png';
import imageIntroducao from '@/assets/achievements/Img-onboarding-tokens-intro.png';
import { ApplicationState } from '@/store';
import { updateAchievementsInfoRequest } from '@/store/achievements/actions';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import './style.scss';

interface Props {
    visible: boolean;
    onHide: CallableFunction;
}

const AchievementModalNotification: React.FC<Props> = ({ visible, onHide }) => {
    const [step, setStep] = useState<number>(0);
    const stepActive = 'points-indicators-active';
    const stepDisable = 'points-indicators-steps';
    const styleStartModal = 'box-button-card-notification step-one';
    const styleStepsModal = 'box-button-card-notification box-next-back';

    const { strings, achievementsInfoRead } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        achievementsInfoRead: state.identity.data.person.achievementsInfoRead,
    }));

    const dispatch = useDispatch();
    const history = useHistory();

    const stepsContents = [
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_INTRODUCTION,
            subtitle: strings.ACHIEVEMENTS.NEWS.SUBTITLE_STEP_INTRODUTIONS,
            image: imageIntroducao,
        },
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_ONE,
            subtitle: strings.ACHIEVEMENTS.NEWS.SUBTITLE_STEP_ONE,
            image: imgOnboarding01,
        },
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_TWO,
            subtitle: strings.ACHIEVEMENTS.NEWS.SUBTITLE_STEP_TWO,
            image: imgOnboarding02,
        },
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_THREE,
            subtitle: strings.ACHIEVEMENTS.NEWS.SUBTITLE_STEP_THREE,
            image: imgOnboarding03,
        },
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_FOUR,
            subtitle: strings.ACHIEVEMENTS.NEWS.SUBTITLE_STEP_FOUR,
            image: imgOnboarding04,
        },
        {
            title: strings.ACHIEVEMENTS.NEWS.TITLE_STEP_FIVE,
            subtitle: '',
            image: imageIntroducao,
        },
    ];

    const nextStep = (): void => {
        if (step < 5) {
            setStep(step + 1);
        }
    };

    const backStep = (): void => {
        if (step > 0) {
            setStep(step - 1);
        }
    };

    const navigateToAchievements = () => {
        onHide();
        history.push(`/achievements/`);
    };

    useEffect(() => {
        if (visible) {
            setStep(0);
        }
    }, [visible]);

    useEffect(() => {
        if (!achievementsInfoRead) {
            dispatch(updateAchievementsInfoRequest());
        }
    }, []);

    return (
        <Modal backdrop={true} dialogClassName="modal-notification-card" show={visible} onHide={onHide}>
            <Modal.Header closeButton />

            <div className={step > 0 || step === 5 ? 'image-card-notification' : 'image-card-notification lets-go'}>
                <figure>
                    <img src={stepsContents[step].image} alt={stepsContents[step].title} />
                </figure>
            </div>
            <div className="title-card">
                <h5>{stepsContents[step].title}</h5>
            </div>
            <div className="description-card">
                <span dangerouslySetInnerHTML={{ __html: stepsContents[step].subtitle }} />
            </div>

            <div className={step === 0 || step === 5 ? styleStartModal : styleStepsModal}>
                <button
                    className="button-back-card"
                    onClick={() => {
                        backStep();
                    }}
                >
                    <i className="material-icons">trending_flat</i>
                </button>
                <div className="box-steps">
                    {stepsContents.map((item, index) => (
                        <div key={item.title} className={step === index ? stepActive : stepDisable}></div>
                    ))}
                </div>
                <button
                    className="button-next-card"
                    onClick={() => {
                        nextStep();
                    }}
                >
                    <i className="material-icons">trending_flat</i>
                </button>

                <button
                    className="button-lets"
                    onClick={() => {
                        step === 5 ? navigateToAchievements() : nextStep();
                    }}
                >
                    {strings.ACHIEVEMENTS.NEWS.BOT_LETS_GO}
                </button>
            </div>
        </Modal>
    );
};

export default AchievementModalNotification;
